export default "__VITE_ASSET__6ea3ac93__"